import React from "react";
import { Button } from "react-bootstrap";
import SocketIOFileUpload from 'socketio-file-upload';
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import { __, API, getElement, defaultAvatar, getUID, decode } from "../../../../Helper";
import C from "../../../../Constant";

let _defaultAvatar = defaultAvatar;

class Avatar extends React.Component {
    _isMounted = false;
    instance = null;
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            avatar: storage.getKey('avatar') !== 'null' ? storage.getKey('avatar') : _defaultAvatar
        };
        this.responseStatus = this.responseStatus.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.instance = new SocketIOFileUpload(socket);
        this.instance.addEventListener("start", function (event) {
            event.file.meta.token = storage.getKey('token');
        });
        this.instance.listenOnInput(getElement("#avatar-button-file"));
        socket.on(C.SAVE_AVATAR, data => this.responseStatus(decode(data)));
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.instance.removeEventListener("start", this.instance.prompt, false);
        this.instance.destroy();
        this.instance = null;
    }

    responseStatus(data) {
        if (this._isMounted) {
            let { status, file } = data;
            if (status === true) {
                let avatar = API + '/uploads/' + file;
                storage.setKey('avatar', avatar);
                this.setState({ avatar: avatar });
            }
        }
    }

    chooseAvatar = () => {
        if (this._isMounted) {
            getElement("#avatar-button-file").click();
        }
    };

    render() {
        let { avatar } = this.state;
        if (avatar === null || !avatar) {
            avatar = "/assets/images/avatar.png";
        }
        return (
            <div className={"avatar-upload my-0 text-center"}>
                {/* <div className="position-relative d-inline-block p-1" style={{
                    borderRadius: '50%',
                    border: '2px solid rgba(16, 185, 129, 0.3)',
                    background: 'rgba(255,255,255,0.05)',
                    boxShadow: '0 0 20px rgba(16, 185, 129, 0.1)'
                }}>
                    <img src={avatar} className={'thumb-lg bg-dark rounded-circle'} alt="Avatar" style={{ border: '2px solid rgba(255,255,255,0.1)' }} />
                </div> */}
                {/* 
                <div className="mt-3">
                    <button
                        onClick={(e)=> this.chooseAvatar(e)}
                        className="btn btn-sm btn-link text-success pulse-animation p-0 font-weight-bold"
                        style={{ textDecoration: 'none', fontSize: '0.8rem' }}
                    >
                        <i className={"mdi mdi-camera-plus mr-1"}/>
                        Update Profile Picture
                    </button>
                    <input
                        accept="image/*"
                        id="avatar-button-file"
                        type="file"
                        className="d-none"
                    />
                </div>
                */}
            </div>
        );
    }
}

export default Avatar;